export function isRenderedInBrowser(): boolean {
  return typeof document === 'object' && typeof window === 'object';
}

export function isRenderedOnServer(): boolean {
  return !isRenderedInBrowser();
}
